interface RulesDialogData {
  title: string;
  content: string;
}

let globalVisible = false;
let globalData: RulesDialogData = { title: "", content: "" };
let globalListeners: Array<(visible: boolean, data: RulesDialogData) => void> =
  [];

const notifyListeners = () => {
  globalListeners.forEach(listener =>
    listener(globalVisible, { ...globalData })
  );
};

export const openGlobalRulesDialog = (title: string, content: string) => {
  globalVisible = true;
  globalData = { title, content };
  notifyListeners();
};

export const closeGlobalRulesDialog = () => {
  globalVisible = false;
  notifyListeners();
};

export const subscribeRulesDialog = (
  listener: (visible: boolean, data: RulesDialogData) => void
) => {
  globalListeners.push(listener);
  if (globalVisible) {
    listener(globalVisible, { ...globalData });
  }
  return () => {
    globalListeners = globalListeners.filter(l => l !== listener);
  };
};

export const getRulesDialogState = () => ({
  visible: globalVisible,
  data: { ...globalData },
});

export type { RulesDialogData };
